<ng-container *ngIf="configTable && !loadingData && !item">
    <div class="container">
        <div class="col-12 text-center" *ngIf="displayTitle">
            <h2>{{ titleForm }}</h2>
        </div>
        <form class="col-12" [formGroup]="entityForm" #form="ngForm" (ngSubmit)="save(form)">
            <div class="row">
                <ng-container *ngFor="let field of columns">
                    <ng-container *ngIf="field.formType" [ngSwitch]="field.formType">
                        <ng-container *ngIf="entityForm.get(field.fieldName); let ctrl">
                            <ng-container *ngSwitchCase="TYPES.NUMBER">
                                <div class="col-12">
                                    <mat-form-field appearance="legacy" class="full-width">
                                        <mat-label>
                                            {{ field.label ? field.label : field.fieldName }}
                                        </mat-label>
                                        <input matInput [formControlName]="field.fieldName" appNumberDirective
                                            type="number" [required]="true" />
                                         <mat-error *ngIf="ctrl.invalid">
                                            {{getError(field, ctrl)}}
                                        </mat-error>
                                        <mat-icon matSuffix *ngIf="field?.helpText" class="icon-help"
                                            matTooltip="{{field.helpText}}">
                                            help_outline
                                        </mat-icon>
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="row justify-content-end py-3">
                <button mat-raised-button type="button" mat-dialog-close class="mx-2">Cancelar</button>
                <button [disabled]="entityForm.invalid" mat-raised-button type="button" color="primary"
                    (click)="validate(form)">Continuar</button>
            </div>
        </form>
    </div>
</ng-container>
<div *ngIf="item">
    <mat-dialog-content>
        <div class="col-12 text-center" *ngIf="displayTitle">
            <h2>Información {{ configTable.name }}</h2>
        </div>
        <mat-list>
            <ng-container *ngFor="let field of this.columnsView">
                <ng-container *ngIf="field.formType && item[field.fieldName]" [ngSwitch]="field.formType">
                    <ng-container *ngSwitchCase="TYPES.DATE">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{ item[field.fieldName] | date: 'dd-MM-yyyy'}}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.TEXT_AREA">
                        <mat-list-item style="height: auto">
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}
                                    :</p>
                            </div>
                            <div class="{{classContent}}">
                                <p style="white-space: pre-wrap; word-break: break-word">{{ item[field.fieldName] }}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.NUMBER">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{ item[field.fieldName] }}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.DECIMAL">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{ item[field.fieldName] }}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.TEXT">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{ item[field.fieldName] }}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.CURRENCY">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{ item[field.fieldName] | currency }}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                    <ng-container *ngSwitchCase="TYPES.DROPDOWN">
                        <mat-list-item>
                            <div class="{{classLabel}}">
                                <p class="font-weight-bold">{{ field.label ? field.label : field.fieldName }}:</p>
                            </div>
                            <div class="{{classContent}}">
                                <p>{{getDataDropdown(field)}}</p>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>
                </ng-container>
            </ng-container>
        </mat-list>
    </mat-dialog-content>
    <mat-dialog-actions class="row justify-content-end mr-2">
        <button mat-stroked-button color="primary" mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="primary" (click)="changeCencos()">Guardar</button>
    </mat-dialog-actions>
</div>